import type { ReactNode } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import clsx from 'clsx'

const GradientBorderWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: ${rem(2)};
  border-radius: ${rem(22)};
  background: linear-gradient(
    135deg,
    ${props => props.theme.palette.product.ai.light} 0%,
    ${props => props.theme.palette.product.ai.dark} 50%,
    ${props => props.theme.palette.product.ai.light} 100%
  );
  box-shadow: 0 0 ${rem(8)} ${props => props.theme.palette.product.ai.light35},
              0 ${rem(2)} ${rem(12)} ${props => props.theme.palette.product.ai.dark25};

  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

const InputContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border-radius: ${rem(20)};
  padding: ${rem(12)} ${rem(16)};
  gap: ${rem(8)};
  transition: padding 0.2s ease;

  &.compact {
    padding: ${rem(6)} ${rem(14)};
  }
`

interface Props {
  compact?: boolean
  disabled?: boolean
  children: ReactNode
}

function ChatInputShell({ compact = false, disabled = false, children }: Props) {
  return (
    <GradientBorderWrapper className={clsx({ disabled })}>
      <InputContainer className={clsx({ compact })}>
        {children}
      </InputContainer>
    </GradientBorderWrapper>
  )
}

export default ChatInputShell
